var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"id":"app-home"}},[_c('div',{staticClass:"bloc px-5"},[_c('div',{staticClass:"headline text-center mt-50 mb-8"},[_vm._v("\n      "+_vm._s(_vm.$t('info.payment_preparation'))+"\n    ")]),_vm._v(" "),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"white"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }